import { render } from "./svg-welfare-party.vue?vue&type=template&id=902038e2"
import script from "./svg-welfare-party.vue?vue&type=script&lang=ts"
export * from "./svg-welfare-party.vue?vue&type=script&lang=ts"
script.render = render

export default script